import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import { getWindowSize } from "../../../utils/generalUtils";
import { setColor, setFont } from "../../../assets/styles/styles";
import IntraverseMiniLogoIcon from "../assets/logos/ColoredIntraverseLogo.png";
import { default as Button } from "../../../components/common/button/Button";
import HamburgerIcon from "../../../assets/images/icons/UC_Sprite_Icon_Menu.png";
import X from "../../../assets/images/buttonIcons/purpleX.png";
import Wave from "../../../assets/images/graphics/UC_Graphic_Wave.png";

const LandingHeader = ({ explorePage, setExplorePage, isPro, setIsPro, isAbout, setIsAbout }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [windowSize, setWindowSize] = useState(getWindowSize());

    const navigate = useNavigate();

    const routeChange = (path) => {
        navigate(path);
    };

    const resetHook = () => {
        setExplorePage(false);
        setIsPro(false);
        setIsAbout(false);
    };

    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }
        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);

    return (
        <StickyContainer>
            {windowSize.innerWidth > 768 ? (
                <>
                    <DropdownContainer>
                        <ElementContainer>
                            <LogoAndDropDownContainer>
                                <PortalHeaderLogo
                                    onClick={() => routeChange("/")}
                                    src={IntraverseMiniLogoIcon}
                                    alt="Intraverse Logo"
                                />
                                <MenuItem
                                    onClick={() => {
                                        resetHook();
                                        setIsAbout(true);
                                    }}
                                    isSelected={isAbout}
                                >
                                    About
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        resetHook();
                                        setIsPro(true);
                                    }}
                                    isSelected={isPro}
                                >
                                    Pro
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        resetHook();
                                        setExplorePage(true);
                                    }}
                                    isSelected={explorePage}
                                >
                                    Explore
                                </MenuItem>
                            </LogoAndDropDownContainer>
                            <PortalHeaderMenuButtons>
                                <Button
                                    onClick={() => routeChange("/login")}
                                    onHoverColor
                                    label="SIGN IN"
                                    variant="TextButton"
                                    style={{
                                        padding: "15px 20px",
                                    }}
                                />
                                <Button
                                    boxShadow="none"
                                    borderRadius="0"
                                    onClick={() => routeChange("/login")}
                                    label="PLAY"
                                    variant="LandingHeaderButton"
                                />
                            </PortalHeaderMenuButtons>
                        </ElementContainer>
                    </DropdownContainer>
                </>
            ) : (
                <>
                    <MobileNavigation>
                        <MobileTopNav>
                            <PortalHeaderLogo
                                onClick={() => routeChange("/")}
                                src={IntraverseMiniLogoIcon}
                                alt="Intraverse Logo"
                            />
                            <HamburgerMenu onClick={() => setIsOpen(!isOpen)} src={HamburgerIcon} alt="Menu" />
                        </MobileTopNav>
                        {isOpen && (
                            <>
                                <MobileOverlay isOpen={isOpen} />
                                <MobileMenu>
                                    <MobileMenuTopContainer>
                                        <PortalHeaderLogo
                                            onClick={() => routeChange("/")}
                                            src={IntraverseMiniLogoIcon}
                                            alt="Intraverse Logo"
                                            style={{
                                                position: "absolute",
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                width: "40px",
                                                height: "27px",
                                            }}
                                        />
                                        <CloseIcon src={X} alt="Close" onClick={() => setIsOpen(!isOpen)} />
                                    </MobileMenuTopContainer>
                                    <MobileMenuContainer>
                                        <MobileMenuWrapper>
                                            <MobileMenuItem
                                                isSelected={isAbout}
                                                onClick={() => {
                                                    resetHook();
                                                    setIsAbout(true);
                                                    setIsOpen(false);
                                                }}
                                            >
                                                About
                                            </MobileMenuItem>
                                            <MobileMenuItem
                                                isSelected={isPro}
                                                onClick={() => {
                                                    resetHook();
                                                    setIsPro(true);
                                                    setIsOpen(false);
                                                }}
                                            >
                                                Pro
                                            </MobileMenuItem>
                                            <MobileMenuItem
                                                isSelected={explorePage}
                                                onClick={() => {
                                                    resetHook();
                                                    setExplorePage(true);
                                                    setIsOpen(false);
                                                }}
                                            >
                                                Explore
                                            </MobileMenuItem>
                                        </MobileMenuWrapper>
                                        <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                            <Button
                                                label="Sign In"
                                                variant="PurpleButton"
                                                onClick={() => {
                                                    routeChange("/login");
                                                    setIsOpen(false);
                                                }}
                                                backgroundColor={setColor.brightVioletTransparent10}
                                                margin={"-5px auto"}
                                                buttonWidth={"90%"}
                                                buttonMobileWidth={"85%"}
                                                style={{ margin: "0 auto" }}
                                            />
                                        </div>
                                    </MobileMenuContainer>
                                    <WaveImage src={Wave} alt="Wave" />
                                </MobileMenu>
                            </>
                        )}
                    </MobileNavigation>
                </>
            )}
        </StickyContainer>
    );
};

export default LandingHeader;

const StickyContainer = styled.div`
    position: fixed;
    top: 0;
    display: flex;
    z-index: 100000;
    width: 100%;
`;
const DropdownContainer = styled.div`
    position: absolute;
    display: flex;
    justify-content: flex-start;
    background-color: transparent !important;
    align-items: center;
    width: 100%;
    height: auto;
    // padding: 0 20px;
    z-index: 1000;
    border-bottom: 2px solid ${setColor.brightVioletTransparent};
`;

const ElementContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    // max-width: 1300px; /* Limit the maximum width */
    padding-left: 20px;
    // margin: 0 auto;
`;

const LogoAndDropDownContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1;
    gap: 20px;
`;

const Dropdowns = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: auto;
    // margin: 0 auto;
    margin-top: 23px;
`;

const MobileNavigation = styled.div`
    position: absolute;
    width: 100%;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: transparent !important;
    z-index: 1000;
    border-bottom: 1px solid ${setColor.brightVioletTransparent};
`;

const MobileTopNav = styled.div`
    position: sticky;
    width: 100%;
    top: 0;
    display: flex;
    justify-content: ${(props) => (props.isCenter ? "center" : "space-between")};
    align-items: center;
    background-color: transparent !important;
    z-index: 1001;
    height: 30px;
    padding: 0 20px;

    @media (max-width: 768px) {
        height: 60px;
    }
`;

const MobileMenuTopContainer = styled.div`
    width: 100%;
    position: relative;
    padding-bottom: 40px;
    border-bottom: 1px solid ${setColor.brightVioletTransparent};
`;

const MobileMenuContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: calc(100% - 70px);
`;

const MobileMenuWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 10px;
    margin-top: 10px;
`;

const PortalHeaderLogo = styled.img`
    cursor: pointer;
    width: 40px;
    height: 27px;

    @media (min-width: 768px) and (max-width: 1024px) {
        max-width: 80px;
        margin-left: 0rem;
    }
`;

const PortalHeaderMenuButtons = styled.div`
    border-left: 2px solid ${setColor.brightVioletTransparent};
    @media (max-width: 768px) {
        margin: 0px;
        display: none;
    }
`;

const MobileMenu = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 45vh;
    background: ${setColor.linearPurple};
    border-bottom: "1px solid ${setColor.brightVioletTransparent}";
    z-index: 1002;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
    border-radius: 0 0 10px 10px;
    overflow: hidden;

    &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        border-bottom: 1px solid rgba(157, 117, 245, 0.3);
    }
`;
const MenuItem = styled.div`
    padding: 12px 0px;
    margin: 0px 10px;
    color: ${(props) => (props.isSelected ? setColor.brightViolet100 : "#9D9D9D")};
    border-bottom: ${(props) => `5px solid ${props.isSelected ? setColor.brightViolet100 : "transparent"}`};
    font-family: ${setFont.barlow};
    font-size: 19px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    font-style: normal;
    line-height: normal;
    cursor: pointer;
    text-align: center;
    width: fit-content;
    transition:
        background-color 0.3s ease,
        color 0.3s ease;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
        color: ${setColor.brightViolet100};
    }

    &:first-child {
        background-color: transparent;
        justify-content: flex-start;
    }
`;

const MobileMenuItem = styled.div`
    padding: 10px 20px;
    color: ${(props) => (props.isSelected ? setColor.brightViolet100 : "rgba(255, 255, 255, 0.5)")};
    font-family: ${(props) => (props.isSelected ? setFont.barlow : setFont.marlow)};
    font-size: 24px;
    font-weight: ${(props) => (props.isSelected ? "700" : "500")};
    font-style: normal;
    line-height: normal;
    text-transform: capitalize;
    cursor: pointer;
    text-align: center;
    width: 90%;
    border-radius: 5px;
    transition:
        background-color 0.3s ease,
        color 0.3s ease;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
        background-color: ${setColor.brightVioletTransparent};
    }

    &:first-child {
        background-color: transparent;
        justify-content: flex-start;
    }
`;

const MobileOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1001;
    display: ${(props) => (props.isOpen ? "block" : "none")};
`;

const CloseIcon = styled.img`
    position: absolute;
    right: 15px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    z-index: 1003;
`;

const HamburgerMenu = styled.img`
    width: 30px;
    height: 30px;
    cursor: pointer;
    // margin-top: 30px;
    padding: 8px;
    background-color: ${setColor.brightVioletTransparent10};
    border-radius: 7px;
    box-sizing: content-box;
`;

const WaveImage = styled.div`
    position: absolute;
    bottom: 0;
    left: 65%;
    width: 40%;
    height: 80%;
    background: url(${Wave}) no-repeat center bottom;
    background-size: cover;
    z-index: 999;

    @media (max-width: 768px) {
        display: block;
        left: 73%;
    }
`;
